import type { CSSProperties } from 'react';

interface StandardTitleLineProps {
  /** Standard (Emtrain) title; nothing renders when it is absent. */
  standardTitle?: string;
  style?: CSSProperties;
}

/**
 * NA-449: muted "Standard: <title>" line shown under a list row's title when a
 * client account's customized title differs from the standard one.
 */
export function StandardTitleLine({ standardTitle, style }: StandardTitleLineProps) {
  if (!standardTitle) return null;
  return <div style={style}>Standard: {standardTitle}</div>;
}
